import { z } from 'zod';
import { ShipmentMethod } from '../../enums/crew.js';
import { ShippingApiProvider } from '../../enums/enum.js';
export const rate = z.object({
    id: z.string(),
    carrier: z.string(),
    cost: z.number(),
    service: z.string(),
    carrierAccountId: z.string(),
    currency: z.string(),
});
const quoteBase = z.object({
    iconImgUrl: z.string(),
    storeRuleId: z.number().nullable(),
    returnLocation: z.object({
        id: z.number(),
    }),
});
const labelReturnMethod = z
    .object({
    type: z.literal(ShipmentMethod.label),
    provider: z.union([
        z.literal(ShippingApiProvider.easyPost),
        z.literal(ShippingApiProvider.vesyl),
    ]),
    shipmentFromPlatform: z.object({
        id: z.string(),
        rate,
    }),
})
    .merge(quoteBase);
export const packingSlipReturnMethod = z
    .object({
    type: z.literal(ShipmentMethod.packingSlip),
})
    .merge(quoteBase);
const HappyReturnMethodId = {
    'return-bar': 'return-bar',
    'retailer-store': 'retailer-store',
    mail: 'mail',
    'mail-nolabel': 'mail-nolabel',
    'mail-nobox-nolabel': 'mail-nobox-nolabel',
};
const happyReturnLocation = z.object({
    // happy returns' own location id, not always present on their response
    idFromPlatform: z.string().nullish(),
    name: z.string(),
    timeZone: z.string().nullish(),
    hoursMayVary: z.boolean().nullish(),
    distance: z.number().nullish(),
    mapUrl: z.string().nullish(),
    address: z.object({
        name: z.string().nullish(),
        address: z.string().nullish(),
        address2: z.string().nullish(),
        city: z.string().nullish(),
        state: z.string().nullish(),
        zipcode: z.string().nullish(),
        countryCode: z.string().nullish(),
    }),
    openingHours: z
        .array(z.object({
        // 1 = Monday ... 7 = Sunday
        dayOfWeek: z.number().nullish(),
        openingTime: z.string().nullish(),
        closingTime: z.string().nullish(),
    }))
        .default([]),
    promotions: z
        .array(z.object({
        label: z.string(),
        value: z.string(),
    }))
        .default([]),
});
const happyReturnMethod = z.object({
    type: z.literal(ShipmentMethod.consolidatedDropoff),
    provider: z.literal(ShippingApiProvider.happyReturns),
    retailerId: z.string(),
    idFromPlatform: z.literal(HappyReturnMethodId['return-bar']),
    dropoffLocations: z.array(happyReturnLocation),
});
const globalEReturnMethod = z.object({
    type: z.literal(ShipmentMethod.label),
    provider: z.literal(ShippingApiProvider.globalE),
    globalEOrderId: z.string(),
    globalEShippingMethodId: z.number(),
    storeRuleId: z.number().nullable(),
    shipmentFromPlatform: z.object({
        id: z.number(),
        rate: rate
            .pick({
            cost: true,
            currency: true,
            carrier: true,
            service: true,
        })
            .extend({
            originalRateCost: z.number().optional(),
            originalRateCurrency: z.string().optional(),
        }),
    }),
    returnLocation: z.object({
        id: z.number(),
    }),
});
// not a discriminatedUnion: labelReturnMethod and globalEReturnMethod share
// `type: 'Label'` and are distinguished by `provider`
export const returnShipmentMethod = z.union([
    packingSlipReturnMethod,
    globalEReturnMethod,
    labelReturnMethod,
    happyReturnMethod,
]);
//# sourceMappingURL=shipmentRate.js.map